import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    username: window.localStorage.getItem('username') == null ? '' : window.localStorage.getItem('username'),
    sessionId: window.localStorage.getItem('sessionId') == null ? '' : window.localStorage.getItem('sessionId'),
  },
  mutations: {
    username (state, username) {
      state.username = username;
      window.localStorage.setItem('username', username);
    },
    sessionId (state, sessionId) {
      state.sessionId = sessionId;
      window.localStorage.setItem('sessionId', sessionId);
    }
  }
})
